<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:90px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Pavilions</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div>
        <div class="title_fontStyle  h2"><i class="fas fa-caret-right"></i> Pavilions</div>
        <h5 class="mt-5 ">
          Continuously brings in trends, technologies, and issues discussed by industry experts.
        </h5>

        <p>&zwnj;</p>

        <div class="accordion" id="accordionPavilions">
          <div class="card" v-for="(item, index) in PavilionsList">
            <div class="card-header " id="headingOne">
              <div class="d-flex justify-content-between align-items-center">
                <button
                  class="btn btn-link "
                  type="button"
                  data-toggle="collapse"
                  :data-target="`#${item.PavilionsId}`"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                  @click="getExhList(item.PavilionName)"
                >
                  <i class="fas fa-chevron-circle-down"></i>
                  {{ item.PavilionName }} （{{ item.ExhibitorCount }}）
                </button>
              </div>
            </div>

            <div
              :id="item.PavilionsId"
              class="collapse my-3"
              aria-labelledby="headingOne"
              data-parent="#accordionPavilions"
            >
              <div class="ListStyle BannerHover" style="font-size:14px" v-for="(items, index) in ExhList">
                <span v-if="clickTitle == items.ComName" class="text-primary" @click.prevent="goExhDetail(items.RegNo)">
                  {{ index + 1 }}. {{ items.ComName }}
                </span>

                <span v-else @click.prevent="goExhDetail(items.RegNo, items.ComName)"
                  >{{ index + 1 }}. {{ items.ComName }}</span
                >
              </div>
            </div>
          </div>

          <p>&zwnj;</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        token: '',
        CSRF_Token: '',
        PavilionsList: [],
        PavilionsList2: [],
        getFirstData: '',
        ExhList: [],
        clickTitle: '',
      }
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'exhcode']),
    },

    methods: {
      getExhList(id) {
        const vm = this

        vm.$http
          .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/PavilionsExhibitors/${vm.exhcode}?Pavilion=${id}&Lang=en`)
          .then((response) => {
            vm.ExhList = response.data
          })
      },

      goExhDetail(RegNo, ComName) {
        const vm = this
        vm.clickTitle = ComName
        window.open(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/ExhibitorDetail/${RegNo}`)
      },
    },

    created() {
      const vm = this

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })

      //取得全展覽名稱
      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Pavilions/${vm.exhcode}`).then((response) => {
        // console.log(response.data)

        vm.PavilionsList = response.data
        vm.PavilionsList2 = response.data

        for (let i = 0; i < vm.PavilionsList2.length; i++) {
          vm.PavilionsList2[i].PavilionsId = `A${i}`

          vm.PavilionsList = vm.PavilionsList2
        }

        //先取得第一筆資料
        vm.getFirstData = vm.PavilionsList2[0].PavilionName

        vm.getExhList(vm.getFirstData)
      })
    },
  }
</script>

<style lang="scss" scoped>
  .EventBanner {
    transition: all 0.3s;
    background-size: cover;
    background-repeat: no-repeat;
    border: 1px solid gray;
    border-radius: 10px;
  }

  .EventTitle {
    font-size: 15px;
    line-height: 24px;
  }

  .btn-link {
    font-weight: 550;
    color: #343434;
    text-decoration: none;
    font-size: 17px;
  }

  .btn-link.focus,
  .btn-link:focus,
  .btn-link:hover,
  .btn-link:active {
    color: #343434;
  }

  .btn.focus,
  .btn:focus {
    box-shadow: 0px 0px rgb(14, 13, 13);
  }

  .ListStyle {
    padding-top: 7px;
    padding-bottom: 5px;
    padding-left: 30px;
    padding-right: 30px;
  }
</style>
